module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-field-wrapper"
  }, _vm._l((_vm.items), function(item, idx) {
    return (item) ? _c('div', {
      key: idx,
      staticClass: "item",
      class: {
        'selected': _vm.Value && (_vm.Value === item || _vm.Value.id === item.id)
      },
      on: {
        "click": function($event) {
          return _vm.onClickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "choice"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.name)))])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b869e8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/radio.vue
// module id = 409
// module chunks = 0